export const AUTH_REGISTER_WIDE = '/media/auth/register-wide.jpg';
export const AUTH_REGISTER_TALL = '/media/auth/register-tall.jpg';
